import React, {useEffect} from 'react';
import Modal from '../../UI/ModalPopup';
import IdleContent from '../dashboard/IdleContent';
import {detectIfIdle} from '../../common/helper';
import {useDispatch, useSelector} from 'react-redux';
import {selectIsIdle, setIsIdle} from './hocSlice';
const SHOW_IDLE_POPUP_DELAY = 300000; //5 mins
const SEND_UNSUBSCRIBE_DELAY = 30000; //30 sec


const IdleDetection = ({children, onIdleHandler, onActiveHandler}) => {
    const isIdle = useSelector(selectIsIdle);
    const dispatch = useDispatch();

    useEffect(() => {
        setTimeout(() => {
            if (isIdle) {
                onIdleHandler();
            }
        }, SEND_UNSUBSCRIBE_DELAY);
    }, [isIdle]);

    useEffect(() => {
        !isIdle && detectIfIdle(showIdleModal, SHOW_IDLE_POPUP_DELAY);
    }, [isIdle])

    const onModalActionClick = () => {
        onActiveHandler();
        dispatch(setIsIdle(false));
    };

    const showIdleModal = () => {
        dispatch(setIsIdle(true));
    };

    return (
        <>
            {children}
            <Modal show={isIdle}
                   onCloseClick={onModalActionClick}
                   onActionClick={onModalActionClick}
                   body={<IdleContent/>}
                   btnText='Continue'
                   hideCancelOption={true}
            />
        </>
    )
};

export default IdleDetection;